export default {
    methods: {
        input() {
            if (this.checked instanceof Array) {
                const checked = this.checked.slice();
                const found = checked.indexOf(this.value);
                if (found !== -1) {
                    checked.splice(found, 1);
                } else {
                    checked.push(this.value);
                }

                this.$emit('input', checked);
                return;
            }

            this.$emit('input', ! this.checked);
        },
    },
};